// Import the functions you need from the SDKs you need

// import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  addDoc,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

const db = getFirestore(app);

const getApplicants = async () => {
  const applicantsCollection = collection(db, "applicants");
  const applicantSnapshot = await getDocs(applicantsCollection);
  const applicantList = applicantSnapshot.docs.map((doc) => doc.data());
  return applicantList;
};

const saveApplication = async (data) => {
  // data is a plain object with fields like email, firstName, lastName, social, intro, job
  // optionally data.cv can be an object with name, type, size, downloadURL
  const payload = {
    ...data,
    createdAt: serverTimestamp(),
  };

  // create the application document
  const docRef = await addDoc(collection(db, "applicants"), payload);

  // if cv info is provided, save a small record in a subcollection
  if (data.cv && typeof data.cv === "object") {
    try {
      const applicationDoc = doc(db, "applicants", docRef.id);
      const cvFileSubCollectionRef = collection(applicationDoc, "cvFile");
      await addDoc(cvFileSubCollectionRef, {
        fileName: data.cv.name || null,
        fileType: data.cv.type || null,
        fileSize: data.cv.size || null,
        downloadURL: data.cv.downloadURL || null,
        uploadedAt: serverTimestamp(),
      });
    } catch (err) {
      // don't fail the whole save if cv subcollection write fails
      console.warn("Failed to save CV metadata:", err);
    }
  }

  return docRef.id;
};

export { saveApplication, getApplicants };
